import { render, staticRenderFns } from "./TenderInfoPanel.vue?vue&type=template&id=1cddc681&scoped=true"
import script from "./TenderInfoPanel.vue?vue&type=script&lang=js"
export * from "./TenderInfoPanel.vue?vue&type=script&lang=js"
import style0 from "./TenderInfoPanel.vue?vue&type=style&index=0&id=1cddc681&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cddc681",
  null
  
)

export default component.exports